/* eslint-disable camelcase */
import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { selectMomentLocalizer } from 'models/localization';

interface AttendeeActivityLogItemProps {
  log: {
    action_at: any;
    booth_id: string;
    booth_name: string;
    event_action: string;
    event_domain: string;
    event_info: string;
    event_type: string;
    user_email: string;
    user_first_name: string;
    user_last_name: string;
    user_phone: string;
    user_token: string;
    user_uuid: string;
  }
}

const UserActivityLogTimeItem = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px;
  font-size: 12px;
`;

const UserActivityLogTimeColumn = styled.div<{ $marginRight?: boolean }>`
  flex: 1;
  ${({ $marginRight }) => $marginRight && 'margin-right: 4px;'}
`;

const UserActivityLogTimeContainer = styled.div`
  width: 100%;
  height: 100%;
  border-left: 2px solid #C4C4C4;
  border-radius: 2px;
  padding-left: 8px;

  display: flex;
  align-items: center;
`;

const AttendeeActivityLogItem: FC<AttendeeActivityLogItemProps> = ({
  log: {
    user_first_name: userFirstName,
    user_last_name: userLastName,
    event_type: eventType,
    action_at: actionAt,
    event_info: eventInfo,
    user_token: userToken,
    user_uuid: userUuid,
  },
}) => {
  const { t } = useTranslation();
  const momentLocalizer = useSelector(selectMomentLocalizer);
  const eventMessage = useMemo(() => {
    switch (eventType) {
      case 'Enter':
        return t('activity_log.enter_booth_message', 'Entered the booth');
      case 'File_View':
        return t('activity_log.file_view_message', 'Viewed file(s)');
      case 'Meetup':
        return t('activity_log.meetup_attempt', 'Tried to schedule Meetup');
      default:
        return null;
    }
  }, [t, eventType]);

  if (eventMessage) {
    return (
      <UserActivityLogTimeItem>
        <UserActivityLogTimeColumn $marginRight>
          <UserActivityLogTimeContainer>
            {momentLocalizer(new Date(actionAt.toDate())).format('YYYY-MM-DD HH:mm:ss')}
          </UserActivityLogTimeContainer>
        </UserActivityLogTimeColumn>
        <UserActivityLogTimeColumn>
          {eventMessage}
        </UserActivityLogTimeColumn>
      </UserActivityLogTimeItem>
    );
  }
  return null;
};

export default AttendeeActivityLogItem;
